module.exports = __webpack_public_path__ + "static/media/interaction-toggle-checkmark-multi-select-off.fdff9f67.svg";